"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStatus = void 0;
/**
 * ApplicationStatus is an ENUM for indicating the type of Finch Application.
 */
var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus["UNSPECIFIED"] = "UNSPECIFIED";
    ApplicationStatus["TEST"] = "TEST";
    ApplicationStatus["LIVE"] = "LIVE";
    ApplicationStatus["SANDBOX"] = "SANDBOX";
})(ApplicationStatus = exports.ApplicationStatus || (exports.ApplicationStatus = {}));
